module.exports = __webpack_public_path__ + "img/Real-Time-Point-Cloud-video-cover.81e6593.jpg";